import Route from '@ember/routing/route';
import { service } from '@ember/service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export default class OauthQboDisconnectedRoute extends Route {
  @service declare navbarSettings: NavbarSettingsService;

  model() {
    this.navbarSettings.title = 'Disconnected to QuickBooks Online';
  }
}
